// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c8b738a7","732":"629c0254","977":"a324cff6"}[chunkId] + ".chunk.js";
};